import {
  sampleColumnsCreator,
  SamplesColumnsBaseProps,
} from './sampleColumnsCreator';

export const samplesGenericColumns = (props: SamplesColumnsBaseProps) => {
  return sampleColumnsCreator({
    t: props.t,
    columns: { afterIndex: 0, columns: [] },
    hideStopFollowing: props.hideStopFollowing,
  });
};
